<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisPhotochemical',
  routeInfo: {
    label: '光化学组分分析',
    icon: 'fa fa-line-chart'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/index.vue